"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

var _common = require("../../utils/common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AffiliatesService = function AffiliatesService(HttpService) {
  "ngInject";

  var getDataSource = function getDataSource(successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("affiliates/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend
        },
        create: {
          url: _env2.default.getApiUrl("affiliates/create"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { type: "date", editable: false, validation: { required: true } },
            "code": { nullable: false, validation: { required: true } },
            "startDate": { type: "date", nullable: false, validation: { required: true } },
            "expireDate": { type: "date", nullable: false, validation: { required: true } },
            "affiliateName": { nullable: false, validation: { required: true } },
            "affilateType": { defaultValue: 0 },
            "creditAmount": { defaultValue: 0 },
            "activationsCount": { defaultValue: 0 },
            "activationsLimit": { defaultValue: 0 },
            "paymentType": { defaultValue: 0 },
            "emailPattern": {},
            "id": {}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  var getAffiliateUsersDataSource = function getAffiliateUsersDataSource(id, successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("affiliates/affiliateusers/" + id),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": {}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  var getAffiliateJobsDataSource = function getAffiliateJobsDataSource(id, successCb) {
    var dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: _env2.default.getApiUrl("affiliates/affiliatejobs/" + id),
          contentType: "application/json",
          type: "GET",
          beforeSend: _onBeforeSend
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "id": {}
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    });

    return dataSource;
  };

  return { getDataSource: getDataSource, getAffiliateUsersDataSource: getAffiliateUsersDataSource, getAffiliateJobsDataSource: getAffiliateJobsDataSource };
};

function _getResourceLocation(options) {
  return _env2.default.getApiUrl("affiliates/" + options.id);
}

function _onBeforeSend(req) {
  var token = "Bearer " + window.localStorage.getItem("bigfootAccessToken");

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if (type == "read") {
    var filters = [];

    if (data.filter) filters = data.filter.filters;

    var query = (0, _assign2.default)({}, { filters: filters }, data);
    delete query.filter;

    console.log("Query::", query);

    return (0, _stringify2.default)(query);
  }

  if (type == "create") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    delete data.id;
    data.expireDate = _common2.default.converToUtcDate(data.expireDate);
    data.startDate = _common2.default.converToUtcDate(data.startDate);

    if (data.affiliateType && data.affiliateType.value) {
      data.affiliateType = data.affiliateType.value;
    }

    if (data.paymentType && data.paymentType.value) {
      data.paymentType = data.paymentType.value;
    }

    if (data.secondaryPaymentType && (0, _typeof3.default)(data.secondaryPaymentType) === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
      data.secondaryPaymentType = data.secondaryPaymentType.value;
    }

    console.log("Data::", data);

    return (0, _stringify2.default)(data);
  }

  if (type == "update") {

    // Dates used in the DataSource are JavaScript Date objects.
    // Therefore convert the date to utc before sending to remove dateoffset.

    data.expireDate = _common2.default.converToUtcDate(data.expireDate);
    data.startDate = _common2.default.converToUtcDate(data.startDate);

    if (data.affiliateType && data.affiliateType.value) {
      data.affiliateType = data.affiliateType.value;
    }

    if (data.secondaryPaymentType && (0, _typeof3.default)(data.secondaryPaymentType) === 'object' && data.secondaryPaymentType.hasOwnProperty('value')) {
      data.secondaryPaymentType = data.secondaryPaymentType.value;
    }

    console.log("Data::", data);

    return (0, _stringify2.default)(data);
  }
}

exports.default = AffiliatesService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/affiliates.service.js
 **/